import React, { FC } from 'react'
import { getPriceWithSymbol } from '../../views'

import { Column } from '../column'
import { InfoRow } from '../info-row'
import { ItemLineMobile } from '../item-line'

import { useStyle } from './order-control-item-line.styles'
import { OrderControlItemLineProps } from './order-control-item-line.types'

export const OrderControlItemLineMobile: FC<OrderControlItemLineProps> = ({
  className,
  productName,
  currency,
  imgUrl,
  quantity,
  deliveryPrice,
  items,
  noSuggestion,
  description,
  discount,
  days,

  totalOfferPrice,
  productDefaultPrice,
  isTooltip
}) => {
  const classes = useStyle()

  return (
    <ItemLineMobile
      className={className}
      productName={productName}
      imgUrl={imgUrl}
      noSuggestion={noSuggestion}
      description={description}
      discount={discount}
      totalOfferPrice={totalOfferPrice}
      items={items}
      deliveryPrice={deliveryPrice}
      productDefaultPrice={productDefaultPrice}
      currency={currency}
      isTooltip={isTooltip}
    >
      <Column fullWidth className={classes.infoRows}>
        <InfoRow
          title="Production Days:"
          titleTx="shopping.cart.production.days"
          value={String(days)}
        />
        <InfoRow
          className={classes.row}
          title="Item Quantity:"
          titleTx="shopping.cart.units.quantity"
          value={String(quantity)}
        />
        <InfoRow
          className={classes.row}
          title="Order Price:"
          titleTx="shopping.cart.order.price"
          value={getPriceWithSymbol(totalOfferPrice, currency)}
        />
        <InfoRow
          className={classes.row}
          title="Delivery Price:"
          titleTx="shopping.cart.item.delivery.price"
          value={getPriceWithSymbol(deliveryPrice, currency)}
        />
      </Column>
    </ItemLineMobile>
  )
}
